"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.nearbyRead = void 0;
const DirectionsInput_1 = require("./DirectionsInput");
const GoogleMapsController_1 = __importDefault(require("./GoogleMapsController"));
async function nearbyRead(coordinates, radiusM, options) {
    return GoogleMapsController_1.default.request('place/nearbysearch', [
        ['location', (0, DirectionsInput_1.directionsInputString)(coordinates)],
        ['radius', String(radiusM)],
    ], options);
}
exports.nearbyRead = nearbyRead;
